import React, { useEffect, useRef } from "react";
import "./Pre.css";

function Pre({ load }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!load) return;
    
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let animationId;
    let characters = "01";
    let fontSize = 14;
    let columns;
    let drops;

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      columns = canvas.width / fontSize;
      drops = [];
      for (let i = 0; i < columns; i++) {
        drops[i] = 1;
      }
    };

    const draw = () => {
      ctx.fillStyle = "rgba(0, 0, 0, 0.04)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = "#17c500";
      ctx.font = fontSize + "px monospace";

      for (let i = 0; i < drops.length; i++) {
        const text = characters.charAt(Math.floor(Math.random() * characters.length));
        ctx.fillText(text, i * fontSize, drops[i] * fontSize);
        if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
        }
        drops[i]++;
      }
      animationId = requestAnimationFrame(draw);
    };

    resizeCanvas();
    draw();
    window.addEventListener("resize", resizeCanvas);

    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener("resize", resizeCanvas);
    };
  }, [load]);

  if (!load) return null;

  return (
    <div id="preloader" className="preloader-container">
      <canvas ref={canvasRef} className="matrix-canvas"></canvas>
      <div className="preloader-overlay">
        <div className="preloader-content">
          <div className="soc-badge-large">
            <span className="bracket">[</span>
            <span className="soc-name">SOC</span>
            <span className="bracket">]</span>
          </div>
          <div className="preloader-status">
            <p>Initializing security environment...</p>
            <p>Loading threat detection modules...</p>
            <p className="blink-cursor">Ready<span className="cursor">█</span></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pre;